import { ReactElement } from "react";
import Layout from "../../components/layout";
import AddNeighborhood from "../../components/Neighborhood/AddNeighborhood";

const NeighborhoodAddPage = (): ReactElement => {
  return (
    <Layout>
      <AddNeighborhood />
    </Layout>
  );
};

export default NeighborhoodAddPage;
